import { FormSelectYesNo } from '../../formelements'

export const AuthImatgeMaterial = ({
  enguany, anyVinent,
  authIntranet, handleChangeIntranet, errorIntranet,
  authPublicacions, handleChangePublicacions, errorPublicacions,
  authInternet, handleChangeInternet, errorInternet,
  authMaterial, handleChangeMaterial, errorMaterial,
  authMaterialInicials, handleChangeMaterialInicials, errorMaterialInicials,
}) => {
  return (<>
  <div className="row">
    <div className="col col-12 ">
      <h4>
        Autorització relativa a l’alumnat major de
        14 anys i del personal docent i no docent
        del centre: ús d’imatges, publicació de
        dades de caràcter personal i de material
        que elaboren. Curs {enguany}-
        {anyVinent}
      </h4>
      <p>
        El centre disposa d’espais de comunicació
        i difusió, inclosos els espais web (adreça
        o adreces web), on informa i fa difusió de
        les activitats escolars lectives,
        complementàries i extraescolars. En
        aquests espais es poden publicar
        imatges/veu en què aparegui,
        individualment o en grup, alumnat i
        personal docent que fa les activitats
        esmentades. El dret a la pròpia imatge és
        reconegut en l’article 18.1 de la
        Constitució espanyola i està regulat per
        la Llei orgànica 1/1982, de 5 de maig,
        sobre el dret a l’honor, a la intimitat
        personal i familiar i a la pròpia imatge,
        per la qual cosa la direcció d’aquest
        centre demana el consentiment per publicar
        fotografies i vídeos on surti alumnat i
        personal docent que hi sigui clarament
        identificable.
      </p>

      <p>
        Autoritzo mentre mantingui vinculació amb
        el centre
      </p>

      <p>
        1. Que la meva imatge/veu pugui sortir en
        fotografies i/o vídeos corresponents a
        activitats escolars lectives,
        complementàries i extraescolars
        organitzades pel centre i publicades en: -
        En webs del centre:
      </p>
    </div>
  </div>

  <div className="row">
    <div className="col col-12 ">
      <FormSelectYesNo
        id="authIntranet"
        name="authIntranet"
        col="col-4"
        label="Intranet amb accés restringit:"
        obligatori={true}
        value={authIntranet}
        handleChange={(e) => handleChangeIntranet(e.target.value) }
        error={errorIntranet}
      />

      <FormSelectYesNo
        id="authPublicacions"
        name="authPublicacions"
        col="col-4"
        label="Publicacions del centre"
        obligatori={true}
        value={authPublicacions}
        handleChange={(e) => handleChangePublicacions(e.target.value) } 
        error={errorPublicacions}
      />

      <FormSelectYesNo
        id="authInternet"
        name="authInternet"
        col="col-4"
        label="Internet amb accés no restringit"
        obligatori={true}
        value={authInternet}
        handleChange={(e) => handleChangeInternet(e.target.value) } 
        error={errorInternet}
      />
    </div>
  </div>

  <div className="row">
    <div className="col col-12 ">
      <p>
        2. Que el material que elabori pugui ser publicat en els espais de comunicació
        (blogs i espais web i revistes) del mateix centre amb la finalitat de desenvolupar
        l’activitat educativa:
      </p>
    </div>
  </div>

  <div className="row">
    <div className="col col-12 ">

      <FormSelectYesNo
        id="authMaterial"
        name="authMaterial"
        col="col-4"
        label="Autoritzo"
        obligatori={true}
        value={authMaterial}
        handleChange={(e) => handleChangeMaterial(e.target.value) } 
        error={errorMaterial}
      />
    </div>
  </div>

  <div className="row">
    <div className="col col-12 ">
      <p>
      3. Que en els webs o blogs i revistes editades pel centre hi constin les meves inicials i les del centre:
      </p>
    </div>
  </div>

  <div className="row">
    <div className="col col-12 ">

      <FormSelectYesNo
        id="authMaterialInicials"
        name="authMaterialInicials"
        col="col-4"
        label="Autoritzo"
        obligatori={true}
        value={authMaterialInicials}
        handleChange={(e) => handleChangeMaterialInicials(e.target.value) } 
        error={errorMaterialInicials}
      />
    </div>
  </div>

    <br />
  </>)
}
